export default __webpack_public_path__ + "noItems2.ead718f986140057096178bf0d66c39a.svg";